<template>
	<BaseCenteredPage hideHelpButton>
		<template #nav-left>
			<BaseButton class="text-gray-300 text-strong-base" @click="$router.go(-1)">
				<template #icon><BaseIcon name="mono/return" /></template>
				Back
			</BaseButton>
		</template>
		<div class="text-left pt-64">
			<h1 class="text-gray-100 text-strong-base mb-32">About</h1>
			<p>Version: v{{ version }}</p>
			<p>Revision: {{ shortHash }}</p>
			<h2 class="text-gray-100 mt-32 mb-8">Acknowledgements</h2>
			<p>
				{{ $store.productName }} is made possible thanks to these
				<a :href="$env.VUE_APP_URL + '/credits'" target="_blank" class="link-blue">open source projects.</a>
			</p>
			<p class="mt-32 text-gray-400">&#169; {{ year }} {{ $store.productName }}. All rights reserved.</p>
		</div>
	</BaseCenteredPage>
</template>

<script>
import {useTitle} from 'shared/composables/useTitle'

export default {
	name: 'About',
	setup() {
		useTitle('About')
	},
	data() {
		return {
			version: import.meta.env.VUE_APP_VERSION,
			shortHash: import.meta.env.VUE_APP_SHORT_HASH,
			year: new Date().getFullYear(),
		}
	},
}
</script>
